import React from 'react';
import { Select } from '../../components/Common';
import FacilityDeletionModal from '../../components/Modal/FacilityDeletionModal';

const LANGUAGES = [
    { value: 'en', label: 'English' },
    { value: 'sv', label: 'Swedish' },
    { value: 'de', label: 'German' },
    { value: 'fi', label: 'Finnish' },
];

const THEME_MODES = [
    { value: 'light', label: 'Light' },
    { value: 'dark', label: 'Dark' },
];

const CustomerAppView = ({
    facilities,
    selectedFacility,
    selectedLanguage,
    selectedThemeMode,
    onFacilityChange,
    onLanguageChange,
    onThemeModeChange,
    webAppLink,
    onboardingAppLink,
}) => {
    if (!facilities || facilities.length === 0) {
        return null;
    }

    const showOnboardingApp = process.env.REACT_APP_ENV === 'development';

    return (
        <div className="card-wrapper customer-details__iframe-wrap">
            <div className="customer-details__iframe-wrap--title-and-link">
                <div className="customer-details__app-view-header">
                    <div className="customer-details__app-view-header--selector">
                        <img src="/assets/icons/home.svg" height={20} className="icon" alt="Facility" title="Facility" />
                        <Select
                            name="facility"
                            onChange={e => onFacilityChange(e.target.value)}
                            options={facilities.map(facility => ({
                                value: facility.facility_id,
                                label: facility.retailer_facility_id,
                            }))}
                            value={selectedFacility}
                        />
                    </div>
                    <div className="customer-details__app-view-header--selector">
                        <img src="/assets/icons/language.svg" height={20} className="icon" alt="Language" title="Language" />
                        <Select name="language" onChange={e => onLanguageChange(e.target.value)} options={LANGUAGES} value={selectedLanguage} />
                    </div>
                    <div className="customer-details__app-view-header--selector">
                        <img src="/assets/icons/palette.svg" height={20} className="icon" alt="Theme" title="Theme" />
                        <Select name="theme" onChange={e => onThemeModeChange(e.target.value)} options={THEME_MODES} value={selectedThemeMode} />
                    </div>
                </div>
                <div className="customer-details__iframe-wrap--links">
                    {showOnboardingApp && (
                        <a href={onboardingAppLink} target="_blank" rel="noreferrer">
                            Onboarding App
                            <i className="fa-solid fa-arrow-up-right-from-square"></i>
                        </a>
                    )}
                    <a href={webAppLink} target="_blank" rel="noreferrer">
                        Customer App
                        <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </a>
                </div>
            </div>
            <iframe title="customer-app" className="customer-details__iframe-wrap--iframe-web-app" src={webAppLink}></iframe>
            <div className="customer-details__delete-facility">
                <FacilityDeletionModal facilities={facilities} />
            </div>
        </div>
    );
};

export default CustomerAppView;
